import * as React from 'react'

import { useFormContext, useWatch } from 'react-hook-form'

import { Text } from '@enechain/ecloud-designsystem'
import { DealPosition } from '@enechain/eposition-proto/types/v1/deal_pb'
import { createOrderSummaryText } from '@enechain/eposition-ui'

import { OrderSimulationSchema } from '~/pages/Simulation/schemas'

type Props = {
  index: number
}

export const OrderSummaryText: React.FC<Props> = ({ index }) => {
  const { control } = useFormContext<OrderSimulationSchema>()

  const orderPattern = useWatch({
    name: `orderPattern.${index}`,
    control,
  })

  if (orderPattern === undefined) {
    return null
  }

  const {
    spreadType,
    isPhysicalFuture,
    dealPosition,
    baseSummaryOrder,
    exchangeSummaryOrder,
    selfDeliveryType,
    eClearDeliveryType,
  } = orderPattern

  const summary = createOrderSummaryText({
    isSpread: spreadType.isSpreadTrade,
    base: {
      position: dealPosition,
      areaCode: baseSummaryOrder.areaCode,
      deliveryPeriodType: baseSummaryOrder.deliveryPeriodType,
      deliveryDateRange: baseSummaryOrder.deliveryDateRange,
      deliveryHourType: baseSummaryOrder.deliveryHourType,
      volumeInKw: baseSummaryOrder.volumeInKw ?? '',
      unitPricePerKwh: baseSummaryOrder.unitPricePerKwh ?? '',
      selfDeliveryType,
      counterpartyDeliveryType: eClearDeliveryType,
      isPhysicalFuture,
      floatingIndexCode: baseSummaryOrder.floatingIndexCode,
    },
    exchange:
      exchangeSummaryOrder !== undefined
        ? {
            position:
              dealPosition === DealPosition.BID
                ? DealPosition.OFFER
                : DealPosition.BID,
            areaCode: exchangeSummaryOrder.areaCode,
            deliveryPeriodType: exchangeSummaryOrder.deliveryPeriodType,
            deliveryDateRange: exchangeSummaryOrder.deliveryDateRange,
            deliveryHourType: exchangeSummaryOrder.deliveryHourType,
            volumeInKw: exchangeSummaryOrder.volumeInKw ?? '',
            unitPricePerKwh: exchangeSummaryOrder.unitPricePerKwh ?? '',
            selfDeliveryType,
            counterpartyDeliveryType: eClearDeliveryType,
            isPhysicalFuture,
            floatingIndexCode: exchangeSummaryOrder.floatingIndexCode,
          }
        : undefined,
  })

  return (
    <Text textStyle="textMd" color="Text.midEmphasis">
      {summary.value}
    </Text>
  )
}
